import { KYMW1300Model } from '../kymw1300.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { KYMW1300GetPlanTargetListModel } from '../vo/kymw1300-get-plan-target-list.model';
import { PlanTargetList } from '../vo/plan-target-list.model';

/**
 * 商品企画マスタ画面　選定候補一覧(定番タブ)を取得するサービス
 *
 * @export GetPlanTargetListService
 * @class GetPlanTargetListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetPlanTargetListService extends PlessJsonResponderSub<any> {

  /**
   * 処理に使用するModel
   *
   * @private
   * @type {KYMW1300Model}
   * @memberof GetPlanTargetListService
   */
  private model: KYMW1300Model;

  planTargetList: PlanTargetList;
  /**
   * 処理に使用するVO
   *
   * @private
   * @type {KYMW1300GetPlanTargetListModel}
   * @memberof GetPlanTargetListService
   */
  private vo: KYMW1300GetPlanTargetListModel;

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof GetPlanTargetListService
   */
  private successFunc: (model: any) => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetPlanTargetListService
   */
  private getBody(): PlessRequest {
    let conditionList = [];
    let searchObj = {};
    
    if (this.vo.pcodeList.length > 0) {
      // Pコードリスト検索
      this.vo.pcodeList.map((item) => {
        const addItem = {
          parameter: {
            GuideGoodsName: "",
            GuideStandardName: "",
            TagId: "",
            GoodsMark: "",
            CoopCode: "",
            CatalogCode: "",
            PageNo: "",
            Duties: "",
            PCode: item,
            ItemCode: "",
          }
        }
        conditionList.push(addItem);
      })
    } 
    else if (this.vo.itemCodeList.length > 0) {
      // アイテムコードリスト検索
      this.vo.itemCodeList.map((item) => {
        const addItem = {
          parameter: {
            GuideGoodsName: "",
            GuideStandardName: "",
            TagId: "",
            GoodsMark: "",
            CoopCode: "",
            CatalogCode: "",
            PageNo: "",
            Duties: "",
            PCode: "",
            ItemCode: item,
          }
        }
        conditionList.push(addItem);
      })
    } 
    else {
      const guideGoodsName = this.vo.guideGoodsName;
      const guideStandardName = this.vo.guideStandardName;
      const tagId = this.vo.tagId;
      const goodsMark = this.vo.goodsMark;
      const coopCodeList = this.vo.coopCode;
      const catalogCode = this.vo.catalogCode;
      const pageNo = this.vo.pageNo;
      const duties = this.vo.duties;

      const maxLength = Math.max(guideGoodsName.length, guideStandardName.length, tagId.length, goodsMark.length, coopCodeList.length, catalogCode.length, pageNo.length, duties.length);

      conditionList = Array.from({ length: maxLength }, (_, index) => ({parameter: {
        GuideGoodsName: guideGoodsName[index] !== undefined ? guideGoodsName[index] : "",
        GuideStandardName: guideStandardName[index] !== undefined ? guideStandardName[index] : "",
        TagId: tagId[index] !== undefined ? tagId[index] : "",
        GoodsMark: goodsMark[index] !== undefined ? goodsMark[index] : "",
        CoopCode: coopCodeList[index] !== undefined ? coopCodeList[index] : "",
        CatalogCode: catalogCode[index] !== undefined ? catalogCode[index] : "",
        PageNo: pageNo[index] !== undefined ? pageNo[index] : "",
        Duties: duties[index] !== undefined ? duties[index] : "",
        PCode: "",
        ItemCode: "",
      }}))
    }

    searchObj = {
      PlanTargetList: {
        parameter: {
          PCode: this.vo.pcode,
          ItemCode: this.vo.itemCode,
          JanCode: this.vo.janCode,
          MakerName: this.vo.makerName,
          TagSearchType: this.vo.tagSearchType,
          GoodsMarkSearchType: this.vo.goodsMarkSearchType,
          DataKbnFlg: this.vo.dataKbnFlg,
          GoodsDiv: this.vo.goodsDiv,
          BuyerCode: this.vo.buyerCode,
          AdmitStatus: this.vo.admitStatus,
          RegistDateFrom: this.vo.registDateFrom,
          RegistDateTo: this.vo.registDateTo,
          UpdateDateFrom: this.vo.updateDateFrom,
          UpdateDateTo: this.vo.updateDateTo,
          ClassCode: this.vo.classCode,
          MiddleClassCode: this.vo.middleClassCode,
          SmallClassCode: this.vo.smallClassCode,
          OrdrClientCode: this.vo.ordrClientCode,
          OrdrClientKanji: this.vo.ordrClientKanji,
          PayeeClientCode: this.vo.payeeClientCode,
          PayeeClientKanji: this.vo.payeeClientKanji,
          MediumType: this.vo.mediumType,
          SearchMediumType: this.vo.searchMediumType,
          OrderCode: this.vo.orderCode,
          SearchOrderCode: this.vo.searchOrderCode,
          SpecialFeature: this.vo.specialFeature,
          CatalogCodeSearchType: this.vo.catalogCodeSearchType,
          Page: this.vo.page,
          SortItem: this.vo.sortItem,
          SortOrder: this.vo.sortOrder,
        },
        combination: conditionList
      }
    }
    return new PlessRequest({ search: searchObj });
  }


  /**
   * API呼び出し
   *
   * @param model
   * @param vo
   * @param {Function} successFunc 成功時後続処理
   * @memberof GetPlanTargetListService
   */
  execute(model: KYMW1300Model, vo: KYMW1300GetPlanTargetListModel, planTargetList: PlanTargetList, successFunc: (model: any) => void): void {
    this.model = model;
    this.vo = vo;
    this.planTargetList = planTargetList;
    this.successFunc = successFunc;
    this.send('getPlanTargetList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetPlanTargetListService
   */
  success(data: any): void {
    if (data !== null) {
      this.successFunc(data);
    }
  }
}
